import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { SetActiveTab } from '../../../state/reports/actions';
import { ReportsTabs } from '../../../state/reports/state';
import { GameDayRootReducerState } from '../../../state/root.state';
import {
  getGamedayLoadingState,
  getReportsActiveTabState
} from '../../../state/data/reducer';

@Component({
  selector: 'muni-gameday-reports',
  templateUrl: './reports.template.html',
  standalone: false,
})
export class ReportsComponent {
  public readonly loading: Observable<boolean> = this.store.pipe(
    select(getGamedayLoadingState)
  );

  public readonly activeTab: Observable<number> = this.store.pipe(
    select(getReportsActiveTabState),
    distinctUntilChanged()
  );

  constructor(private store: Store<GameDayRootReducerState>) {}

  public onChange({ payload }: { payload: ReportsTabs }): void {
    this.store.dispatch(new SetActiveTab(payload));
  }
}
